<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import DevicePixelRatio from './utils/devicePixelRatio';
export default {

created() {
  console.log(window.devicePixelRatio,'window.devicePixelRatio');
    // new DevicePixelRatio().init();
	}
}
</script>
<style>
.el-dialog{
  border-radius: 12px !important;
}
.el-dialog__header{
  background: #F9F9F9;
  border-radius: 12px 12px 0 0;
}
.el-dialog__title{
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #161616;
}

.ellipsis{
  overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap;
}

.ellipsisTwo{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

td{
  word-break: break-all;
  white-space: pre-line;
}

#app{
  height: 100%;
  background: linear-gradient( 180deg, #D8EEFF 0%, rgba(216,238,255,0) 58%, rgba(216,238,255,0) 100%);
}
body{
  /* zoom: 0.8; */
}
body,html{
  height: 100%;
}

::-webkit-scrollbar{ /*滚动条整体样式*/
    width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}
::-webkit-scrollbar-thumb{ /*滚动条里面小方块*/
    border-radius: 5px;
    background: #cfcbcb;
}
::-webkit-scrollbar-track{ /*滚动条里面轨道*/
    border-radius: 6px;
    background: #ededed;
}

</style>
